// Shared CSV export helper for report screens.
// Quotes every field and escapes embedded quotes so values with commas or
// quotes (e.g. account names) never split into extra columns. Prepends a UTF-8
// BOM and uses CRLF line endings so Excel opens the file cleanly.
//
// rows: array of arrays (each inner array is one CSV row / cells).
// filename: download name, e.g. "trial_balance_2026-07-12.csv".
export const downloadCsv = (rows, filename) => {
  const csv = rows
    .map(row => row.map(v => `"${String(v ?? '').replace(/"/g, '""')}"`).join(','))
    .join('\r\n');
  const blob = new Blob(['﻿', csv], { type: 'text/csv;charset=utf-8;' });
  const url = window.URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  a.click();
  window.URL.revokeObjectURL(url);
};

export default downloadCsv;
